import forgotPasswordRules from './forgotPasswordRules';
import forgotPasswordNewRules from './forgotPasswordNewRules';
import loginRules from './loginRules';
import loginNewRules from './loginNewRules';

export{
	forgotPasswordRules,
	forgotPasswordNewRules,
	loginRules,
	loginNewRules
}